import { GetLibraryStoriesMeta, GetLibraryStoriesPayload } from 'types/store/GetLibraryStories';
import { createAsyncReducer } from 'utils/Redux';

import { getLibraryStoriesActions } from '../actions';

export default createAsyncReducer<GetLibraryStoriesMeta, GetLibraryStoriesPayload>(getLibraryStoriesActions);
